import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const AssignTripIcon = (props) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path
      d="M14.3137 11.5147C14.291 11.3217 14.1327 11.1488 13.9035 11.1488H12.5884V8.86496C12.5884 8.39168 12.3358 7.95233 11.9269 7.71392L8.58838 5.6488L8.58831 2.64882C8.58956 2.56048 8.57324 2.47277 8.5403 2.39079C8.50735 2.30881 8.45845 2.2342 8.39642 2.17128C8.33439 2.10837 8.26047 2.05841 8.17897 2.02431C8.09746 1.99022 8.00999 1.97266 7.92164 1.97266C7.83329 1.97266 7.74582 1.99022 7.66432 2.02431C7.58282 2.05841 7.5089 2.10837 7.44687 2.17128C7.38484 2.2342 7.33593 2.30881 7.30299 2.39079C7.27005 2.47277 7.25373 2.56048 7.25498 2.64882L7.25504 5.6488L3.91521 7.71392C3.50777 7.95281 3.25506 8.39168 3.25506 8.86496V11.1488H1.93995C1.57395 11.1488 1.39025 11.5913 1.64959 11.8506L3.39568 13.598C3.68635 13.8887 4.1571 13.8887 4.44777 13.598L6.19386 11.8506C6.45319 11.5913 6.27016 11.1488 5.90349 11.1488H4.58839V8.86496L4.58969 8.86366L7.92042 6.92095L11.2551 8.86496L11.2551 11.1488H9.93995C9.57395 11.1488 9.39026 11.5913 9.64959 11.8506L11.3957 13.598C11.6864 13.8887 12.1571 13.8887 12.4478 13.598L14.1939 11.8506C14.2911 11.7534 14.3272 11.6305 14.3137 11.5147Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

AssignTripIcon.propTypes = {
  sx: PropTypes.object,
};

export default AssignTripIcon;
